
import { dispatchShowSnack } from '@/store/dispatches'

import { Snack, SnackType } from '@/interfaces/snack'
import router from '../router'

export function showErrors (errors: any): void {
  errors.map((error: any) => {
    if (error.message) {
      dispatchShowSnack({
        msg: error.message,
        type: SnackType.Error
      })
      if (error.message.statusCode === 401) {
        setTimeout(() => {
          router.replace({ name: 'SignIn' })
        }, 1000)
      }
    }
  })
}

export function showNotification (msg: Snack): void {
  dispatchShowSnack(msg)
}
